/* global lang */
import React from 'react';
import Peer from 'simple-peer';

async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default class RemoteVideo extends React.Component {
  constructor(props) {
    super(props);

    this.state = { stream: false, ended: 0 };

    this.peer = null;
    this.bindProps = () => {
      this.peer.on('signal', this.onSignal);
      this.peer.on('stream', this.onStream);
    };
    this.onSignal = this.onSignal.bind(this);
    this.onStream = this.onStream.bind(this);

    this.remoteVideo = React.createRef();
  }

  updatePeer(kind, stream) {
    console.log('peer', this.peer, kind)
    this.peer.replaceTrack(
      this.peer.streams[0]['get' + kind + 'Tracks']()[0],
      stream['get' + kind + 'Tracks']()[0],
      this.peer.streams[0]
    )
  }

  /*mutePeer(kind, mute) {
    console.log('mutePeer', kind, mute)
    this.peer.streams[0]['get' + kind + 'Tracks']()[0].enabled = !mute;
  }*/

  async componentDidMount() {

    /*let iceServers = [
      //window.turn[0],
      //window.turn[1]
      { urls: ["stun:e3.xirsys.com"] },
      {
        username: "37c64336-f784-11e7-8d1a-7ecba4f48dc1",
        credential: "37c643f4-f784-11e7-9e8c-959422817b76",
        urls: ["turn:e3.xirsys.com:80?transport=udp", "turn:e3.xirsys.com:3478?transport=udp", "turn:e3.xirsys.com:80?transport=tcp", "turn:e3.xirsys.com:3478?transport=tcp", "turns:e3.xirsys.com:443?transport=tcp", "turns:e3.xirsys.com:5349?transport=tcp"]
      }
    ];*/
    
    let iceServers = window.turn;

    console.log('iceServers', iceServers)

    this.peer = new Peer({
      initiator: this.props.initiator,
      stream: this.props.stream,
      config: {
        iceServers: iceServers,
        iceTransportPolicy: 'relay'
      }
    });

    this.peer.on('error', err => console.log('error', err))

    this.bindProps();
    const peer = this.peer;
    this.props.client.registerPeerSignal(signal => {
      peer.signal(signal);
    });
    if (this.props.time != -1) {
      if (document.getElementById('counter')) {
        var minutes = Math.floor(this.props.time / 60);
        var seconds = this.props.time % 60;
        var initialTimeStr = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        document.getElementById('counter_txt').innerHTML = lang.chrono.replace('%seconds%', initialTimeStr);
        let time = this.props.time;
        this.inter = setInterval(() => {
          console.log('this.state.ended', this.state.ended);
          time--;
          if (time < 0) {
            if(this.state.ended == 0)
              document.getElementById('counter_txt').innerHTML = lang.ended_chrono;
            else
              document.getElementById('counter_txt').innerHTML = '';
            document.getElementById('counter').classList.add('end');
            /*if(!this.timeout1) {
              this.timeout1 = setTimeout(() => {
                window.appEvents.emit('endCall');
                clearInterval(this.inter);
               
              }, lang.timeoutbyebye)
            }*/
          }
          else{
            var minutes = Math.floor(time / 60);
            var seconds = time % 60;
            var timeStr = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
            document.getElementById('counter_txt').innerHTML = lang.chrono.replace('%seconds%', timeStr);
          }
          if (time == 30) {
            document.getElementById('counter').classList.add('alerte');
            document.getElementById('counter').classList.add('beforeend');
          }
          if (time < 30) {
            document.getElementById('counter').classList.remove('alerte');
          }
        }, 1000)
      }
    }
    
    window.appEvents.on('noMoreInCouple', () => {
      window.appEvents.emit('endCall');
    });
  }


  sendSignal(signal) {
    this.peer.signal(signal);
  }

  componentWillUnmount() {
    clearInterval(this.inter);
    if(this.timeout1)
      clearTimeout(this.timeout1);
    if(this.timeout2)
      clearTimeout(this.timeout2);
    this.props.client.unRegisterPeerSignal();
    this.peer.destroy();
  }

  onSignal(data) {
    this.props.client.sendSignal({ toId: this.props.toId, signal: data });
  }

  onStream(stream) {
    this.setState({ stream: true });
    if ('srcObject' in this.remoteVideo.current) {
      this.remoteVideo.current.srcObject = stream;
    }
    else {
      this.remoteVideo.current.src = window.URL.createObjectURL(stream);
    }

  }

  render() {
    
    let style = {
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            
            };
    
    if(this.state.ended > 0) {
      return (
        <React.Fragment>
        <div className="video remote">
          <div style={ style }>
            { this.state.ended == 1 &&
              <p className={ 'waiting_someone_new' } dangerouslySetInnerHTML={{__html: lang.waiting_someone_new}}>
              </p>
            }
            { this.state.ended == 2 &&
              <p className={ 'waiting_someone_new2' } dangerouslySetInnerHTML={{__html: lang.waiting_someone_new2}}>
              </p>
            }
            <div className="loader_container">
              <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
          </div>
          
        </div>
        <div id="counter">
            <div id="counter_txt"></div>      
            
            <button className="icon icon-user" onClick={() => this.clickNext()}><span>Next</span></button>
        </div>        
        </React.Fragment>
      );
    }
    
    return (
      <React.Fragment>
      
      
      <div className="video remote">
        <div style={ style }>
        <p className={'connectedname'}>{ this.props.name }</p>
          {this.state.stream ? (
            <video ref={this.remoteVideo} height="100%" autoPlay playsInline></video>
          ) : (
              <h1 dangerouslySetInnerHTML={{__html: lang.connecting}}></h1>
            )}
        </div>
      </div>
      
      {true &&
        <div id="counter">
            <div id="counter_txt"></div>
        </div>
      }
      </React.Fragment>
    );
  }
}
